(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define("Index", [
      'jquery',
      'owlCarousel',
      'eventCarousel',
      'newsCarousel',
      'homeFullpage',
      'main.js'
    ], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(
      require('jquery'),
      require('owlCarousel'),
      require('eventCarousel'),
      require('newsCarousel'),
      require('homeFullpage'),
      require('main.js')
    );
  } else {
    // Browser globals (root is window)
    root.returnExports = factory(
      root.jquery,
      root.owlCarousel,
      root.eventCarousel,
      root.newsCarousel,
      root.homeFullpage,
      root.main
    );
  }
}(typeof self !== 'undefined' ? self : this, function ($, owlCarousel, eventCarousel, newsCarousel, homeFullpage, main) {


  $(function () {


    /* Hero Owl slider init - később kiszervezhető külön modul könyvtárba */
    $('.js-hero-slider').addClass('owl-theme');
    $('.js-hero-slider').addClass('owl-carousel');
    var heroSlider = $('.js-hero-slider').owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 6000,
      margin: 50,
      mouseDrag: false,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn'
    });

    heroSlider.on('changed.owl.carousel', function (e) {
      let index = e.page.index;
      $('.c-hero-bgSlider').find('.bgSlide').removeClass("active");
      $('.c-hero-bgSlider').find('.bgSlide').eq(index).addClass('active');
    });

    /**
     * Fullpage init on the home page
     */
    homeFullpage({
      startInitPoint: 1024,
      containerSelector: ".section-wrapper"
    });

    /**
     * Carousel init on events
     */
    eventCarousel({
      containerSelector: ".homePageSection--bottom .events-container",
      itemSelector: ".event-card",
      viewports: {
        0: {
          row: 2,
          width: function () { return (window.innerWidth * 0.8) + "px"; }
        },
        480: {
          row: 2,
          width: function () { return (window.innerWidth * 0.4) + "px"; }
        },
        767: {
          row: 4,
          width: function () { return (window.innerWidth / 2 - 50) + "px"; }
        },
        1024: {
          row: 3,
          width: function () { return (document.querySelector('.events-list > header').clientWidth + 50) + "px"; }
        },
        1200: {
          row: 3,
          width: function () { return (document.querySelector('.events-list > header').clientWidth + (window.innerWidth * 0.0347222)) + "px"; }
        },
        1440: {
          row: 5
        },
        1920: {
          row: 10
        }
      }
    });

    /**
     * Carousel init on news
     */
    newsCarousel({
      containerSelector: ".homePageSection--bottom .news-container .news-container__inner",
      startInitPoint: 768
    });

  });

}));



//////////////////
// WEBPACK FOOTER
// ./js/pages/index/index.js
// module id = 18
// module chunks = 0